<template>
  <div class="address-wrap">
    <el-row class="address-title">
      <el-col
        :span="6"
        @click.native.stop="curIndex = 0"
        :class="{ actived: curIndex === 0 }"
        >{{ zone }}</el-col
      >
      <el-col
        :span="6"
        @click.native.stop="curIndex = 1"
        :class="{ actived: curIndex === 1 }"
        >{{ city }}</el-col
      >
      <el-col
        :span="6"
        @click.native.stop="curIndex = 2"
        :class="{ actived: curIndex === 2 }"
        >{{ area }}</el-col
      >
      <el-col
        :span="6"
        @click.native.stop="curIndex = 3"
        :class="{ actived: curIndex === 3 }"
        >{{ town }}</el-col
      >
    </el-row>
    <el-row>
      <span
        v-for="item in columnList"
        :key="item.id"
        @click="selectItem(item)"
        >{{ item.name }}</span
      >
    </el-row>
    <el-row></el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columnList: "",
      zone: "--",
      city: "--",
      area: "--",
      town: "--",
      curIndex: 0,
      provinceList: [],
      cityList: [],
      areaList: [],
      townList: [],
      addressValue: []
    };
  },
  watch: {
    curIndex(val) {
      if (val === 0) {
        this.columnList = this.provinceList;
      } else if (val === 1) {
        this.columnList = this.cityList;
      } else if (val === 2) {
        this.columnList = this.areaList;
      } else if (val === 3) {
        this.columnList = this.townList;
      }
    }
  },
  mounted() {
    this.getZoneList();
  },
  methods: {
    getZoneList() {
      this.$reqGet("api/store/address/zone_list").then(res => {
        this.provinceList = res.data.data;
        this.columnList = this.provinceList;
      });
    },
    getCityList(zone_id) {
      this.$reqGet("api/store/address/city_list/" + zone_id).then(res => {
        this.cityList = res.data.data;
        this.columnList = this.cityList;
      });
    },
    getAreaList(city_id) {
      this.$reqGet("api/store/address/area_list/" + city_id).then(res => {
        this.areaList = res.data.data;
        this.columnList = this.areaList;
      });
    },
    getTownList(area_id) {
      this.$reqGet("api/store/address/town_list/" + area_id).then(res => {
        this.townList = res.data.data;
        this.columnList = this.townList;
        if (this.townList.length === 0) {
          this.setAddress();
        }
      });
    },
    selectItem(item) {
      if (this.curIndex === 0) {
        this.addressValue = [];
        this.getCityList(item.id);
        this.zone = item.name;
        this.curIndex = 1;
        this.addressValue.push(item.id);
        this.city = "--";
        this.area = "--";
        this.town = "--";
      } else if (this.curIndex === 1) {
        this.addressValue = this.addressValue.splice(0, 1);
        this.getAreaList(item.id);
        this.city = item.name;
        this.curIndex = 2;
        this.addressValue.push(item.id);
        this.area = "--";
        this.town = "--";
      } else if (this.curIndex === 2) {
        this.addressValue = this.addressValue.splice(0, 2);
        this.getTownList(item.id);
        this.area = item.name;
        this.curIndex = 3;
        this.addressValue.push(item.id);
        this.town = "--";
      } else if (this.curIndex === 3) {
        this.addressValue = this.addressValue.splice(0, 3);
        this.town = item.name;
        this.addressValue.push(item.id);
        this.setAddress();
      }
      console.log(this.addressValue);
    },
    setAddress() {
      let address = this.zone + " " + this.city + " " + this.area;
      if (this.town !== "--") {
        address = address + " " + this.town;
      }
      let sbzRegion = {
        label: address,
        value: this.addressValue.join("_")
      };
      this.$emit("setAddress", sbzRegion);
    }
  }
};
</script>

<style lang="less" scoped>
.address-wrap {
  position: absolute;
  z-index: 2000;
  width: 450px;
  min-height: 280px;
  padding: 10px 15px;
  border: 1px solid #ccc;
  color: #005d9f;
  background-color: #fff;
  .address-title {
    line-height: 40px;
    margin-bottom: 4px;
    .el-col {
      text-align: center;
      border-bottom: 2px solid #e2333f;
      cursor: pointer;
      &.actived {
        border: 2px solid #e2333f;
        border-bottom: 0;
      }
    }
  }
  span {
    display: inline-block;
    padding: 5px;
    min-width: 80px;
    line-height: 28px;
    white-space: nowrap;
    cursor: pointer;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/address-tree.vue